import axios from 'axios';

axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');

const api_url = 'https://login.healthfy.com.br/api';

export function ConnectPlayer(cpf){
	axios.post(`${api_url}/solicita`, {
		cpf
	})
		.then((res) => {console.log(res)})
		.catch((err) => {console.log(err)})
}

export function UnconnectPlayer(cpf){
	axios.post(`${api_url}/desconecta`, {
		cpf
	})
		.then((res) => {console.log(res)})
		.catch((err) => {console.log(err)})
}



// WEBPACK FOOTER //
// ./src/services/ConnectService.js